import { render } from "./OrderCompletePage.vue?vue&type=template&id=7014b3dc&ts=true"
import script from "./OrderCompletePage.vue?vue&type=script&lang=ts"
export * from "./OrderCompletePage.vue?vue&type=script&lang=ts"

import "./OrderCompletePage.vue?vue&type=style&index=0&id=7014b3dc&lang=scss"

import exportComponent from "/home/christmasatourhouse-com/www/tickets/releases/202610123691/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__